import { render } from "./TheHeader.vue?vue&type=template&id=6afb3164&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=6afb3164&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6afb3164"

export default script